import React from 'react';

export function renderLineBreak(mobile, fallback = '，') {
  if (mobile) return <br />;
  return fallback;
}
